import React from "react"
import HTMLReactParser from 'html-react-parser';
import useDeviceMedia from "../utils/useDeviceMedia";
import ReadMoreComponent from "../ReadMore/ReadMore";
import './staticContentContact.scss'

const StaticContentContact = ({content}) => {
    const { isCustomMax } = useDeviceMedia({ max: "767.98px" });
    return (
        <section >
            {isCustomMax ?  <ReadMoreComponent content={content} /> : HTMLReactParser(content.replace(/<br\s*[\/]?>/gi, "\n"))
            }
        </section>
    )    
};
export default StaticContentContact